import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function SettingsPage() {
  return <AppPagePlaceholder name="Settings" />;
}
